import React from "react";
import Home from "pages/home/Home";
import CommonRideView from "pages/commonRideInfo/CommonRideView"

function Dashboard() {

  const pickup = sessionStorage.getItem('pickup');
  const drop = sessionStorage.getItem('drop');
  const packageVal = sessionStorage.getItem('package');
  const isHome = ((pickup && drop) || (pickup && packageVal)) ? true : false

  return ( isHome ? <Home/> : <CommonRideView/> )
}

export default Dashboard;
